module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/AddOnCoverSection/accident-to-driver-692104d8b9c34d8f4db41910d9d3024f.png";